import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPLPOEligibility, fetchPLPOProgress } from '../services/plpo-data.service';
import { getIsHubless } from '../reducers/Portal';
import { RequestStatus } from '../interface';
import { selectPLPOExperienceState } from '../selectors/plpo-experience.selectors';
import { dataFetchingErrorHandler } from '../errors/dataFetchingErrorHandler';
const defaultResponse = {
  groupKey: '',
  isEligible: false,
  progress: 0
};
export const getPLPOExperienceThunk = createAsyncThunk('getPLPOExperience', async (portalId, {
  rejectWithValue,
  getState
}) => {
  const state = getState();
  const isHubless = getIsHubless(state);
  if (isHubless || !portalId) {
    return rejectWithValue(defaultResponse);
  }
  try {
    const isEligible = await fetchPLPOEligibility(portalId);
    if (!isEligible) {
      return defaultResponse;
    }
    const [{
      groupKey,
      progress
    }] = await Promise.all([fetchPLPOProgress(portalId)]);
    return {
      groupKey,
      isEligible,
      progress,
      status: RequestStatus.SUCCESS
    };
  } catch (err) {
    const requestError = err;
    dataFetchingErrorHandler('Failed to fetch PLPO experience')(requestError);
    return rejectWithValue(defaultResponse);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      lastInitiated
    } = selectPLPOExperienceState(state);
    // check if lastInitiated is more than 30 seconds ago before fetching data again
    return !lastInitiated || Date.now() - lastInitiated > 1000 * 30;
  }
});